module.exports = __webpack_public_path__ + "img/barberton-xcm.dd962baf.svg";